import { autoinject } from 'aurelia-framework';
import { RouteConfig, Router, RouterConfiguration } from 'aurelia-router';
import { BindingSignaler } from 'aurelia-templating-resources';
import { log } from 'framework/script_utilities/dev-decorators';
import { IdentityService } from 'services/identity-service';
import { requireServices } from 'support/activation';
import { FeatureService } from 'services/features-service';
import { MobileAppService } from 'services/mobile-app-service';
import { NavGroupModel } from 'model/navigation';

@autoinject
export class HomeIndexScreen {
  router: Router;
  menuToggled = false;
  navGroupModels: NavGroupModel[] = [
    {
      isGroup: true,
      name: "lists",
      settings: {
        icon: "fas fa-list",
        linkClass: "--admin",
        admin: true,
        hidden: false
      },
      title: "Lists",
      isExpanded: false,
      items: []
    },
    {
      isGroup: true,
      name: "roles",
      settings: {
        icon: "fas fa-users",
        linkClass: "--admin",
        admin: true,
        hidden: false
      },
      title: "Roles",
      isExpanded: false,
      items: []
    },
    {
      isGroup: true,
      name: "tracking",
      settings: {
        icon: "fas fa-shoe-prints",
        linkClass: "--admin",
        admin: true,
        hidden: false
      },
      title: "Tracking",
      isExpanded: false,
      items: []
    }
  ];

  constructor(private identity: IdentityService, private bs: BindingSignaler, private featureService: FeatureService, private mobileAppService: MobileAppService) { }

  configureRouter(config: RouterConfiguration, router: Router) {
    config.map([
      { route: '', redirect: 'home' },
      { route: 'home', moduleId: 'screens/home-welcome', name: 'home-welcome', title: 'Home', nav: true, settings: { icon: 'fas fa-home' } },
      { route: 'requests', moduleId: 'screens/travel_requests/requests-index', name: 'requests-index', title: 'Travel Requests', nav: true, settings: { icon: 'fas fa-business-time' } },
      { route: 'countries', moduleId: 'screens/common_info/countries-list', name: 'countries-list', title: 'Travel Approvals', nav: true, settings: { icon: 'fas fa-globe-africa' } },
      { route: 'deviationRequests', moduleId: 'screens/deviation_requests/deviation-requests-index', name: 'deviation-requests-index', title: 'Deviation Requests', nav: true, settings: { icon: 'fas fa-clipboard-check' } },
      { route: 'airlines', moduleId: 'screens/common_info/airlines-list', name: 'airlines-list', title: 'Airlines Rating', nav: true, settings: { icon: 'fas fa-plane-departure' } },
      /*{ route: 'countryChangeRequest', moduleId: 'screens/administration/country-change-request-create', name: 'country-change-request-create', title: 'Countries Settings', nav: true, settings: { icon: 'fas fa-sliders-h' } },*/
      { route: 'website', redirect: 'home', name: 'external-website', title: 'TravelSafe Website', nav: true, settings: { icon: 'fas fa-external-link-alt', clicked: () => window.location.href = this.featureService.contactWebUrl } },
      { route: 'contacts', moduleId: 'screens/common_info/contacts-info', name: 'contacts-info', title: 'Contacts', nav: true, settings: { icon: 'fas fa-phone' } },
      /*{ route: 'holidays', moduleId: 'screens/holiday_trips/trips-index', name: 'trips-index', title: 'Holiday Planner', nav: true, settings: { icon: 'fas fa-umbrella-beach', linkClass: '--admin', admin: true } },*/
      { route: 'admin/countries', moduleId: 'screens/administration/countries-index', name: 'admin-countries-index', title: 'Countries', nav: true, settings: { icon: 'fas fa-globe-africa', linkClass: '--admin', admin: true, groupName: 'lists' } },
      { route: 'admin/questions', moduleId: 'screens/administration/questions', name: 'admin-questions', title: 'Questions', nav: true, settings: { icon: 'fas fa-question-circle', linkClass: '--admin', admin: true, groupName: 'lists' } },
      { route: 'admin/airlines', moduleId: 'screens/administration/airlines-index', name: 'admin-airlines-index', title: 'Airlines', nav: true, settings: { icon: 'fas fa-plane-departure', linkClass: '--admin', admin: true, groupName: 'lists' } },
      { route: 'admin/accommodationTypes', moduleId: 'screens/administration/accommodation-types', name: 'admin-accommodation-types', title: 'Accommodation Types', nav: true, settings: { icon: 'fas fa-hotel', linkClass: '--admin', admin: true, groupName: 'lists' } },
      { route: 'admin/approvalLevels', moduleId: 'screens/administration/approval-levels', name: 'admin-approval-levels', title: 'Approval Levels', nav: true, settings: { icon: 'fas fa-thumbs-up', linkClass: '--admin', admin: true, groupName: 'lists' } },
      { route: 'admin/transportationTypes', moduleId: 'screens/administration/transportation-types', name: 'admin-transportation-types', title: 'Transportation Types', nav: true, settings: { icon: 'fas fa-bus', linkClass: '--admin', admin: true, groupName: 'lists' } },
      { route: 'admin/travelTypes', moduleId: 'screens/administration/travel-types', name: 'admin-travel-types', title: 'Travel Types', nav: true, settings: { icon: 'fas fa-suitcase', linkClass: '--admin', admin: true, groupName: 'lists' } },
      { route: 'admin/countriesRoles', moduleId: 'screens/administration/countries-roles-index', name: 'admin-countries-roles-index', title: 'Countries Roles', nav: true, settings: { icon: 'fas fa-user-tag', linkClass: '--admin', admin: true, groupName: 'roles' } },
      { route: 'admin/deviationTeams', moduleId: 'screens/administration/deviation-teams', name: 'admin-deviation-teams', title: 'Deviation Teams', nav: true, settings: { icon: 'fas fa-users', linkClass: '--admin', admin: true, groupName: 'roles' } },
      { route: 'admin/administrators', moduleId: 'screens/administration/administrators', name: 'administrators', title: 'Administrators', nav: true, settings: { icon: 'fas fa-user-shield', linkClass: '--admin', admin: true, groupName: 'roles' } },
      { route: 'admin/mobileAppDashboard', moduleId: 'screens/administration/mobile-app-dashboard', name: 'admin-mobile-app-dashboard', title: 'Mobile App Dashboard', nav: true, settings: { icon: 'fas fa-map', linkClass: '--admin', admin: true, groupName: 'tracking' } },
      { route: 'admin/locations', moduleId: 'screens/administration/locations/locations-index', name: 'admin-locations', title: 'Locations', nav: true, settings: { icon: 'fas fa-map-marker-alt', linkClass: '--admin', admin: true, groupName: 'tracking' } }
    ]);

    this.router = router;
  }

  private applyPermissions() {
    this.router.navigation.filter(i => i.settings && i.settings['admin'] === true).forEach(i => i.settings['hidden'] = !this.identity.roles.isAdmin);
    this.navGroupModels.filter(i => i.settings && i.settings.admin === true).forEach(i => i.settings.hidden = !this.identity.roles.isAdmin);
  }

  private checkContactWebUrl() {
    this.router.navigation.filter(i => i.config.route === 'website')[0].settings['hidden'] = this.featureService.contactWebUrl ? false : true;
  }
  
  async canActivate() {
    await requireServices(this.identity, this.featureService);
  }

  @log('debug')
  async activate(_params, route: RouteConfig) {
    route.navModel.setTitle(null);
    this.applyPermissions();
    this.checkContactWebUrl();
  }

  menuClicked() {
    return !(this.menuToggled = false);
  }
}
